import type { icons } from '~/components/assets/icons';

type UiNotificationType = 'danger' | 'success' | 'info' | 'warning';
export interface UiNotification {
  message: string;

  action?: { text: string; onClick: (...args: any) => void };
  type: UiNotificationType;
  icon?: keyof typeof icons;
  persist?: boolean;
  id?: symbol;
  dismiss?: () => void;
  ttlInMs?: number;
}

const iconToTypeMap: Record<UiNotificationType, keyof typeof icons> = {
  danger: 'error',
  warning: 'warning',
  info: 'info2',
  success: 'check',
};

const notifications = ref<UiNotification[]>([]);
const maxVisibleNotifications = 5;
const timeToLive = 5000;

const useUiNotification = () => {
  const send = (notification: UiNotification) => {
    const id = Symbol('id');

    const dismiss = () => {
      notifications.value = notifications.value.filter(notification => notification.id !== id);
    };

    const newNotification = {
      ...notification,
      icon: notification.icon ?? iconToTypeMap[notification.type],
      id,
      dismiss,
    };

    notifications.value.push(newNotification);
    if (notifications.value.length > maxVisibleNotifications) {
      notifications.value.shift();
    }

    if (!notification.persist) {
      setTimeout(dismiss, notification.ttlInMs ?? timeToLive);
    }
  };

  return {
    send,
    notifications: computed(() => notifications.value),
  };
};

export default useUiNotification;
